export default function Settings() {
  return (
    <div>
      <h2>Settings</h2>
      <p style={{ opacity: 0.75 }}>Settings are coming soon.</p>
    </div>
  );
}
